import { createEmptySliceBase, injectTableSlice, toReducer } from '../sliceFactory';

const createFinishedTransportsReducer = name => {
  const base = createEmptySliceBase({ name });
  const withTable = injectTableSlice({ sliceBase: base });
  return toReducer(withTable);
};

export default createFinishedTransportsReducer;
